import React from "react";

const GroupName = ({name}) => <span className={"group__name"}>{name}</span>;
export default GroupName;